import React from "react"
import PropTypes from "prop-types"
import HourlyRoundsTimeline from "../HourlyRoundsTimeline"
import { secondsToHoursAndMinutes } from "../../helpers/sharedHelperFunctions"
import "./RoomStatus.scss"
import Loading from "../Loading"

export default class RoomStatus extends React.PureComponent {
  roundsMet = rounds => {
    const roundsMet = rounds.reduce((roundCount, round) => {
      if (round.compliant) return roundCount + 1
      else return roundCount
    }, 0)
    return [roundsMet, rounds.length]
  }

  render() {
    if (!this.props.loading) {
      const rounds = this.roundsMet(this.props.shiftAssignment.rounds)

      return (
        <div className="RoomStatus">
          <div className="top-content">
            <div className="left">
              <div className="left-content">
                <div className="stats">
                  <div className="values">
                    <div>
                      {secondsToHoursAndMinutes(
                        this.props.shiftAssignment.longestGap
                      )}
                    </div>
                    <div>{`${rounds[0]} of ${rounds[1]}`}</div>
                  </div>
                  <div className="labels">
                    <div>Longest Absence</div>
                    <div>Hourly Rounds Met</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom-content">
            <HourlyRoundsTimeline
              rounds={this.props.shiftAssignment.rounds}
              startsAt={this.props.shiftAssignment.startsAt}
              endsAt={this.props.shiftAssignment.endsAt}
              roundingPeriodMinutes={
                this.props.shiftAssignment.roundingPeriodMinutes
              }
            />
          </div>
        </div>
      )
    } else {
      return (
        <div className="RoomStatus loading-container">
          <Loading />
        </div>
      )
    }
  }
}

RoomStatus.propTypes = {
  loading: PropTypes.bool.isRequired,
  shiftAssignment: PropTypes.shape({
    rounds: PropTypes.array,
    longestGap: PropTypes.number,
    startsAt: PropTypes.string.isRequired,
    endsAt: PropTypes.string.isRequired,
    roundingPeriodMinutes: PropTypes.number.isRequired,
  }).isRequired,
}

RoomStatus.defaultProps = {
  isOpen: false,
}
